import Colors from "@constants/Colors";

import CustomSelectInput from "../CustomSelectInput";
import { StyledRootBox, StyledTypography } from "./styles";

interface HederTitleProps {
  title: string;
  handleChange: (type: string) => void;
  value: string;
  options: string[];
}

const HeaderTitle = ({
  title,
  handleChange,
  value,
  options,
}: HederTitleProps) => {
  return (
    <StyledRootBox>
      <StyledTypography color={Colors.primary}>{title}</StyledTypography>
      <CustomSelectInput
        handleChange={handleChange}
        value={value}
        options={options}
      />
    </StyledRootBox>
  );
};

export default HeaderTitle;
